
import { Component, Vue } from "vue-property-decorator";
import PModal from "@/components/look/PModal.vue";
import { Getter } from "vuex-class";

@Component({
  name: "users-guide-modal",
  components: {
    PModal,
  },
})
export default class UsersGuideModal extends Vue {
  @Getter("getUsersGuide") usersGuideBase64!: string;
}
